import type { PropsWithChildren } from "react";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function Portal({ children }: PropsWithChildren) {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    setMountNode(document.body);
  }, []);

  if (!mountNode) {
    return null;
  }

  return createPortal(children, mountNode);
}
